import { UserRole } from 'interfaces';
import { useAppSelector } from 'redux/hooks';
import { authSelectors } from 'redux/modules/Authorization';

export const useCheckRoles = (...rolesToCheck: UserRole[]) => {
  const role = useAppSelector(authSelectors.getUserRole)?.code;
  return !role ? false : rolesToCheck.includes(role);
};
